// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_eb15e31","allInPlayButton":"_2f68e9c"};